import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitolonavalacab() {



  const cardData = {
    keyword: " Mumbai to Lonavala Cab",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Lonavala cab services, ensuring a smooth, safe, and refreshing journey for families, couples, corporate travelers, and weekend tourists. Whether you are planning a quick weekend getaway, monsoon trip, or a scenic hill station break, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Lonavala route covers approximately 80 to 95 km and takes around 1.5 to 2.5 hours depending on traffic conditions and weather. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Lonavala travel.",

"topPlaces": [
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap is one of the most iconic viewpoints in Lonavala, offering a dramatic cliff-top view that resembles a leaping tiger. It provides breathtaking panoramic views of deep valleys, lush green hills, and mist-covered landscapes, especially stunning during monsoon season. Travelers often stop here to enjoy cool winds, photography, and peaceful moments surrounded by nature. Early morning and sunset are the best times to visit for clear views and scenic beauty."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is one of the most popular tourist attractions in Lonavala, especially during the monsoon when water overflows over the steps creating a natural water flow experience. Visitors enjoy splashing in the cool water, relaxing with family, and enjoying the scenic surroundings of the Sahyadri hills. It is a vibrant and crowded weekend destination, ideal for fun outings, but caution is advised during heavy water flow."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a peaceful natural attraction surrounded by hills and greenery, offering a calm escape from city life. It is filled with rainwater during the monsoon season and becomes a scenic picnic spot for families and couples. The lake is also a great place for birdwatching and photography, especially during sunrise and sunset when the reflection of clouds and hills creates a beautiful view."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BC, known for their historical and architectural significance. The main chaitya hall features intricate carvings and one of the largest rock-cut prayer halls in India. Visitors climb steps to reach the caves while enjoying scenic views of the valley, making it both a spiritual and adventurous experience rich in heritage."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point is a famous viewpoint in Lonavala known for its dramatic cliff edges and stunning valley views. It becomes especially popular during monsoon when clouds float below eye level, creating a magical experience. The area is perfect for photography, nature walks, and enjoying local street snacks while soaking in the cool mountain air and scenic landscapes."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic hill fort located between Lonavala and Khandala, known for trekking, adventure, and Maratha history. The trek to the fort passes through forests, waterfalls, and rugged terrain, making it a favorite among adventure lovers. From the top, visitors get panoramic views of the Sahyadri mountains and surrounding valleys, especially beautiful during monsoon."
  },
  {
    "title": "Kune Waterfall",
    "description": "Kune Waterfall is one of the highest waterfalls in Maharashtra and a stunning natural attraction near Lonavala. Surrounded by lush greenery and hills, it offers a breathtaking view, especially during the monsoon season when the water flow is at its peak. Visitors can enjoy photography, relaxation, and the refreshing misty atmosphere created by the falling water."
  },
  {
    "title": "Wax Museum",
    "description": "The Lonavala Wax Museum features lifelike wax statues of famous personalities from India and around the world. It is a popular family attraction offering photo opportunities and entertainment for children and adults. The museum provides a fun indoor experience, especially useful during rainy weather when outdoor sightseeing becomes difficult."
  },
  {
    "title": "Bhaja Caves",
    "description": "Bhaja Caves are ancient Buddhist rock-cut caves located near Lonavala, known for their historical carvings, stupas, and meditation halls. These caves date back over 2,000 years and reflect early Buddhist architecture. The site is peaceful and less crowded, making it ideal for history lovers and those seeking a quiet cultural exploration experience."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a scenic artificial reservoir surrounded by hills, popular for camping, stargazing, and weekend getaways. Visitors from Mumbai often come here to enjoy lakeside camping with bonfires and tents. The peaceful environment, cool breeze, and beautiful sunset views make it one of the most relaxing spots near Lonavala."
  }
],







services: [
  {
    name: "Mumbai to Lonavala Cab",
    description: "Mumbai to Lonavala cab service offers a quick and scenic getaway to one of Maharashtra’s most popular hill stations. The route via the Mumbai-Pune Expressway is known for lush greenery, waterfalls, and mountain views, especially during monsoon. Ideal for weekend trips, couples, families, and corporate outings, this service ensures safe and comfortable travel. Professional drivers and clean vehicles enhance the journey. Multiple car options are available. It guarantees a refreshing and hassle-free trip."
  },
  {
    name: "Mumbai to Lonavala Taxi",
    description: "Mumbai to Lonavala taxi provides convenient door-to-door travel for a relaxing hill station visit. This service is perfect for travelers looking for a private and comfortable ride. Vehicles are well-maintained and driven by experienced chauffeurs. Flexible pickup timings add convenience. Suitable for short trips and weekend travel. It ensures a smooth journey."
  },
  {
    name: "Mumbai to Lonavala Cab Service",
    description: "Mumbai to Lonavala cab service is designed for fast and comfortable intercity travel. The expressway route ensures a smooth and enjoyable drive. This service is ideal for families, couples, and group outings. Vehicles are regularly serviced for performance. Flexible pickup options across Mumbai enhance convenience. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Lonavala Taxi Service",
    description: "Mumbai to Lonavala taxi service offers dependable transportation with a focus on comfort and safety. This service is suitable for tourists, families, and corporate travelers. Clean vehicles and trained drivers ensure a pleasant ride. Flexible scheduling allows easy trip planning. It guarantees a stress-free travel experience."
  },
  {
    name: "Cab from Mumbai to Lonavala",
    description: "Cab from Mumbai to Lonavala provides a personalized travel experience with flexible stops at scenic viewpoints. Travelers can enjoy a relaxed and private ride. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a memorable road trip experience."
  },
  {
    name: "Taxi from Mumbai to Lonavala",
    description: "Taxi from Mumbai to Lonavala offers a convenient and efficient way to travel between the two destinations. With experienced drivers and comfortable vehicles, this service ensures smooth highway travel. Door-to-door pickup and drop add convenience. Suitable for short vacations and day trips. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Lonavala Cab Booking",
    description: "Mumbai to Lonavala cab booking allows travelers to reserve their ride easily with flexible travel options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Lonavala Taxi Booking Online",
    description: "Mumbai to Lonavala taxi booking online provides a quick and convenient way to book your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Lonavala Cab Price",
    description: "Mumbai to Lonavala cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Lonavala Taxi Fare",
    description: "Mumbai to Lonavala taxi fare is designed to be affordable and competitive for short-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Lonavala One Way Cab",
    description: "Mumbai to Lonavala one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for quick trips and weekend plans. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Lonavala Round Trip Taxi",
    description: "Mumbai to Lonavala round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Lonavala Innova Cab",
    description: "Mumbai to Lonavala Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group outings and short trips. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Lonavala Ertiga Cab",
    description: "Mumbai to Lonavala Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Lonavala Sedan Cab",
    description: "Mumbai to Lonavala sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Lonavala SUV Taxi",
    description: "Mumbai to Lonavala SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways and hilly roads. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Lonavala Cab",
    description: "Cheap Mumbai to Lonavala cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Lonavala Taxi Service",
    description: "Best Mumbai to Lonavala taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Lonavala Cab", "Mumbai to Lonavala Taxi"],
  ["Mumbai to Lonavala Cab Service", "Mumbai to Lonavala Taxi Service"],
  ["Cab from Mumbai to Lonavala", "Taxi from Mumbai to Lonavala"],
  ["Mumbai to Lonavala Cab Booking", "Mumbai to Lonavala Taxi Booking Online"],
  ["Mumbai to Lonavala Cab Price", "Mumbai to Lonavala Taxi Fare"],
  ["Mumbai to Lonavala One Way Cab", "Mumbai to Lonavala Round Trip Taxi"],
  ["Mumbai to Lonavala Innova Cab", "Mumbai to Lonavala Ertiga Cab"],
  ["Mumbai to Lonavala Sedan Cab", "Mumbai to Lonavala SUV Taxi"],
  ["Cheap Mumbai to Lonavala Cab", "Best Mumbai to Lonavala Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Lonavala Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Lonavala cab service, perfect for weekend getaways, family trips, and quick hill station visits."
  },
  {
    WhyChooseheading: "Experienced Ghat & Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-trained for Mumbai–Pune Expressway and ghat sections, ensuring safe driving and a relaxed journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Lonavala cab service operates 24/7, allowing flexible travel plans anytime during the day or night."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Lonavala trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Lonavala cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Lonavala cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Lonavala for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Lonavala?", answer: "The distance is approximately 80 to 100 km and takes around 2 to 3 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Lonavala cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak tourist seasons." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Lonavala trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Siddharth Joshi",
    feedback: "The Mumbai to Lonavala cab service with Royal Route Cabs was very smooth and comfortable. The short hill drive was enjoyable and the journey felt safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Patil",
    feedback: "Great experience traveling from Mumbai to Lonavala. The cab was clean, the ride was pleasant, and the service felt reliable and well-organized.",
    rating: 5
  }
];






















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lonavala Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-lonavala-cab.jpg", // replace if needed
  "description": "Book Mumbai to Lonavala cab with Royal Route Cabs for a quick, comfortable, and affordable hill station ride. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel with 24x7 reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-lonavala-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Lonavala Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Lonavala cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to lonavala cab, mumbai to lonavala taxi, mumbai to lonavala cab service, mumbai to lonavala taxi service, cab from mumbai to lonavala, taxi from mumbai to lonavala, mumbai to lonavala cab booking, mumbai to lonavala taxi booking online, mumbai to lonavala cab price, mumbai to lonavala taxi fare, mumbai to lonavala one way cab, mumbai to lonavala round trip taxi, mumbai to lonavala innova cab, mumbai to lonavala ertiga cab, mumbai to lonavala sedan cab, mumbai to lonavala suv taxi, cheap mumbai to lonavala cab, best mumbai to lonavala taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitolonavalacab;